import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../../components/NavBar";
import Login from "../../root/Login";
import {
    Alert,
    Button,
    Card,
    DatePicker,
    Form,
    Popconfirm,
    Popover,
    Select,
    Table,
    TableColumnsType,
    Tag,
    UploadFile
} from "antd";
import Colors from "../../../styles/Colors";
import {
    BiCalendar,
    BiCard,
    BiCheck,
    BiDetail,
    BiDownload,
    BiErrorCircle,
    BiEuro,
    BiFilter,
    BiMessage,
    BiRefresh,
    BiSearch,
    BiTrash
} from "react-icons/bi";
import Historials from "../../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {
    BsBellSlash,
    BsCash,
    BsCheck,
    BsPencil,
    BsPerson,
    BsPersonAdd,
    BsPersonCheck,
    BsTicket,
    BsTicketPerforatedFill
} from "react-icons/bs";
import dayjs, {Dayjs} from 'dayjs';
import toast, {Toaster} from "react-hot-toast";
import {QuestionCircleOutlined} from "@ant-design/icons";
import InscripcioFiltre from "../../../model/multilleure/casals/InscripcioFiltre";
import Activitat from "../../../model/inscripcions/Activitat";
import {GetActivitats} from "../../../dao/multilleure/GetActivitats";
import InscripcioModal from "../../inscripcions/components/InscripcioModal";
import {GetInscripcionsIdInscripcionsId} from "../../../dao/inscripcions/GetInscripcionsIdInscripcionsId";
import {GetInscripcionsActivitatIdTorn} from "../../../dao/inscripcions/GetInscripcionsInscripcioIdTorn";
import {GetInscripcionsActivitatIdExtres} from "../../../dao/inscripcions/GetInscripcionsInscripcioIdExtres";
import {PostInscripcioIdAlumneIdValidar} from "../../../dao/multilleure/casals/PostInscripcioIdAlumneIdValidar";
import {PostInscripcioIdValidar} from "../../../dao/multilleure/casals/PostInscripcioIdValidar";
import {GetInscripcionsActivitatsIdFiltres} from "../../../dao/multilleure/casals/GetInscripcionsActivitatsIdFiltres";
import InscripcioModalDocumentacio from "../../inscripcions/components/InscripcioModalDocumentacio";
import {GetInscripcionsIdAlumneIdDocuments} from "../../../dao/inscripcions/GetInscripcionsIdAlumneIdDocuments";
import {PostInscripcioIdError} from "../../../dao/multilleure/casals/PostInscripcioError";
import {GetLlistats} from "../../../dao/multilleure/casals/GetLlistats";
import {PostInscripcionsFiltrat} from "../../../dao/multilleure/casals/PostInscripcionsFiltrat";
import InfantModal from "../../inscripcions/components/InfantModal";
import PagadorModal from "../../inscripcions/components/PagadorModal";
import DocumentacioModal from "../../inscripcions/components/DocumentacioModal";
import {PostInscripcioFaltaDocumentacio} from "../../../dao/multilleure/casals/PostInscripcioFaltaDocumentacio";
import AutoritzatModal from "../../inscripcions/components/AutoritzatModal";
import InscripcionsDescarregar from "../casals/components/InscripcionsDescarregar";

const InscripcionsE = () => {
    const titol: string = "INSCRIPCIONS";
    const nomPermis: string = "Inscripcions";

    const {isLoggedIn, userId, user, page, token} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id_contacte, id_activitat} = useParams();
    const [idActivitat, setIdActivitat] = useState("0");

    const [showFilters, setShowFilters] = useState(false);
    const [showFiltersButton, setShowFiltersButton] = useState(false);
    const [coleccio, setDades] = useState<any[]>([]);
    const [activitats, setActivitats] = useState<Activitat[]>([]);
    const [elementSelected, setElementSelected] = useState<any>();

    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [editar, setEditar] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);

    const [data, setData] = useState();
    const permisosEdicio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 1);

    const [showDocu, setShowDocu] = useState(false);
    const [showDocuEle, setShowDocuEle] = useState<any>();
    const [docs, setDocs] = useState<UploadFile[]>([]);

    const [filtres, setFiltres] = useState<InscripcioFiltre>(new InscripcioFiltre());

    const [filtreDni, setFiltreDni] = useState([]);
    const [filtreInfant, setFiltreInfant] = useState([]);
    const [filtreUsuari, setFiltreUsuari] = useState([]);
    const [filtreEstat, setFiltreEstat] = useState([]);
    const [filtreEmail, setFiltreEmail] = useState([]);

    const [filtreCasal, setFiltreCasal] = useState<any>([{label: "TOT", value: 0}]);
    const [filtreCampus, setFiltreCampus] = useState<any>([{label: "TOT", value: 0}]);
    const [filtreOpcio, setFiltreOpcio] = useState<any>([{label: "TOT", value: 0}]);
    const [filtreExtres, setFiltresExtres] = useState<any>([{label: "TOT", value: 0}]);

    const [descarregar, setDescarregar] = useState<any>(false);
    const [descarregarModal, setDescarregarModal] = useState(false);
    const [llistats, setLlistats] = useState<[]>([]);
    const [llistaActivitats, setLlistaActivitats] = useState<Activitat[]>([]);

    const [inscripcioInfantModal, setInscripcioInfantModal] = useState(false);
    const [infantModal, setInfantModal] = useState(false);
    const [contacteModal, setContacteModal] = useState(false);
    const [documentacioModal, setDocumentacioModal] = useState(false);
    const [contactesModal, setContactesModal] = useState(false);
    const [selectedContacte, setSelectedContacte] = useState<any>();
    const [infantSelected, setInfantSelected] = useState<any>();

    const [form] = Form.useForm();

    useEffect(() => {
        if (isLoggedIn) {
            if (id_contacte === undefined) {
                getActivitats();
                if (idActivitat !== "0") {
                    handleLoadingChange(true)
                    checkDades(idActivitat);
                } else
                    handleLoadingChange(false);
            } else {
                handleLoadingChange(true)
                setIdActivitat(id_activitat + "");
                checkDades(id_activitat + "");
            }
        }
    }, [id_contacte, id_activitat]);

    function submit() {
        //console.log("Contenido de rebutFiltre:", JSON.stringify(filtres, null, 2));
        checkDades(idActivitat);
    }

    async function togleNouElement(element: any, edit: boolean) {
        handleLoadingChange(true)

        const dad = await GetInscripcionsIdInscripcionsId(element.id_inscripcio + "", element.id_alumne_casal + "", page);
        setData(dad);
        //console.log(">>>>"+JSON.stringify(dad));

        const trn = await GetInscripcionsActivitatIdTorn(dad.id_casal, page);
        const ext = await GetInscripcionsActivitatIdExtres(dad.id_casal, page);

        setElementSelected(convertirJSON(dad, trn, ext));
        setNouElement(!nouElement);
        setEditar(edit);
        handleLoadingChange(false);
    }

    async function handleSubmit() {
        handleLoadingChange(true)
        const formData = form.getFieldsValue();
        console.log("Form Data:", formData);
        console.log(JSON.stringify(formData));

        const dad = await PostInscripcionsFiltrat(formData, page);
        setDades(dad);
        handleLoadingChange(false);
    }

    function convertirJSON(jsonSegundo: any, trn: any, ext: any): any {

        let jsonPrimero: any = {
            infant: jsonSegundo.infant,
            escola: jsonSegundo.escola,
            curs: [jsonSegundo.cicle, jsonSegundo.curs],
            id_alumne_casal: jsonSegundo.key,
            id_inscripcio: jsonSegundo.id_inscripcio,
            alergens: jsonSegundo.alergens,
            observacions: jsonSegundo.observacions,
            activitat: [jsonSegundo.id_activitat, jsonSegundo.id_casal, jsonSegundo.id_campus, jsonSegundo.id_escola_entrada],
            comentaris: jsonSegundo.comentaris
        };

        trn.forEach((element: any, index: any) => {
            const key = `setmanes-${index}`;
            const filteredData = jsonSegundo.configuracions.filter((item: any) => item.id_torn === element.id);
            const formattedSetmanes = filteredData.length > 0 ? filteredData[0].setmanes.map((fecha: string) => dayjs(fecha)) : [];
            jsonPrimero[key] = formattedSetmanes;
        });
        trn.forEach((element: any, index: any) => {
            const key = `dies-${index}`;
            const filteredData = jsonSegundo.configuracions.filter((item: any) => item.id_torn === element.id);
            const formattedSetmanes = filteredData.length > 0 ? filteredData[0].dies.map((fecha: string) => dayjs(fecha)) : [];
            jsonPrimero[key] = formattedSetmanes;
        });


        ext.forEach((element: any, index: any) => {
            const key = `extra-${index}`;
            const filteredData = jsonSegundo.extres ? jsonSegundo.extres.filter((item: any) => item.id_extra === element.id && item.value !== '') : [];
            jsonPrimero[key] = filteredData.length > 0 ? (filteredData[0].valor === 'true' ? true :
                (filteredData[0].valor === 'false' ? false : filteredData[0].valor)) : undefined;
        });


        console.log("-----" + JSON.stringify(jsonPrimero));
        return jsonPrimero;
    }


    async function getActivitats() {
        const act: Activitat[] = await GetActivitats(page);
        setLlistaActivitats(act);
        const llistes = await GetLlistats(nomPermis, page);
        setLlistats(llistes);
        setActivitats(act);
        if (act.length === 1) {
            handleLoadingChange(true);
            setIdActivitat(act[0].id + "");
            //console.log(act[0].id);
            const newFiltres = {...filtres, activitat: act[0].id};
            setFiltres(newFiltres);
            const dades = await PostInscripcionsFiltrat(newFiltres, page);
            setDades(dades);
            const fil = await GetInscripcionsActivitatsIdFiltres(token, act[0].id + "", page);
            updateFiltres(fil);
            setDescarregar(true);
            handleLoadingChange(false);
        }
        setShowFiltersButton(true);
    }

    async function checkDades(id_activitat: string) {
        setShowFiltersButton(false);
        setDescarregar(false);
        if (showFilters) setShowFilters(false);
        if (id_activitat !== "0") {
            handleLoadingChange(true)
            const filtres = await GetInscripcionsActivitatsIdFiltres(token, id_activitat, page);
            setIdActivitat(id_activitat);
            var newFiltres;
            if (id_contacte !== undefined) {
                newFiltres = {...filtres, activitat: id_activitat, idUsuari: id_contacte};
            } else {
                newFiltres = {...filtres, activitat: id_activitat};
            }
            setFiltres(newFiltres);
            const dades = await PostInscripcionsFiltrat(newFiltres, page);
            setDades(dades);
            updateFiltres(filtres);
            setDescarregar(true);
            handleLoadingChange(false);
        }
        setShowFiltersButton(true);
    }

    function updateFiltres(json: any) {
        setFiltreDni(json.dnis);
        setFiltreInfant(json.infants);
        setFiltreEmail(json.email);
        setFiltreUsuari(json.usuaris);
        setFiltreEstat(json.estats);

        setFiltreCasal(json.casals);
        setFiltresExtres(json.extres);

    }

    function toggleTable() {
        setVisible(!visible);
    }

    async function deleteElement(element: any) {
        await PostInscripcioIdValidar(element.id + "", "0", page);
        await checkDades(idActivitat);
    }

    async function deleteElementAlu(element: any) {
        await PostInscripcioIdAlumneIdValidar(element.id_inscripcio + "", element.id_alumne_casal + "", "0", page);
        await checkDades(idActivitat);
    }

    async function validarAlumne(element: any) {
        await PostInscripcioIdAlumneIdValidar(element.id_inscripcio + "", element.id_alumne_casal + "", "2", page);
        await checkDades(idActivitat);
    }

    function afegirElement(element: any) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function handleCloseModal(value: boolean) {
        if (value) {
            toast.success("GUARDAT");
            checkDades(idActivitat);
        } else
            toast.error("NO GUARDAT");
        setNouElement(false);
        setInfantModal(false);
        setDocumentacioModal(false);
        setContactesModal(false);
    }

    function handleCloseModalContacte(value: boolean) {
        if (value) {
            toast.success("GUARDAT");
            checkDades(idActivitat);
        } else
            toast.error("NO GUARDAT");
        setContacteModal(false);
        setInscripcioInfantModal(false);
        setContactesModal(false);
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    /**
     * FILTRES
     **/

    const handleNumberInput = (newIdRebut: number | null, attributeName: string) => {
        const idRebut = newIdRebut || 0;
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: idRebut,
        }));
    };

    const handleStringInput = (event: React.ChangeEvent<HTMLInputElement>, attributeName: string) => {
        const value = event.target.value || "";  // Usar una cadena vacía si el valor es nulo
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: value,
        }));
    };


    const handleDateInput = (value: Dayjs | null, attributeName: string, format: string) => {
        const date = value && value.format(format) || "";

        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: date,
        }));
    };


    async function validar(element: number) {
        await PostInscripcioIdValidar(element + "", "2", page);
        await checkDades(idActivitat);
    }

    function editarInscripcio(ele: any) {
        navigate(`/inscripcions/gestio/${ele.id}`);
        //window.open(`/inscripcions/gestio/${ele.id}`, "_blank");
    }

    function tickets(ele: any) {
        navigate(`/artsiesports/rebuts/${ele.id}`);
    }

    async function informarError(ele: any) {
        await PostInscripcioIdError(ele.id + "", page);
        await checkDades(idActivitat);
    }

    async function faltaDocumentacio(ele: any) {
        await PostInscripcioFaltaDocumentacio(ele.id + "", page);
        await checkDades(idActivitat);
    }

    function afegirInfant(ele: any) {
        const newEle = {id: 0, id_inscripcio: ele.id};
        setInfantSelected(newEle);
        setInfantModal(true);
    }

    function afegirInscripcio(ele: any) {
        const newEle = {id_inscripcio: ele.id};
        setElementSelected(newEle);
        setInscripcioInfantModal(true);
    }

    function afegirAutoritzat(ele: any) {
        setElementSelected(ele);
        setContactesModal(true)
    }

    /**
     * --- FILTRES ----
     **/

    const columns: ColumnsType<any> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            defaultSortOrder: 'descend',
            width: 5,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {

            key: 'pagador',
            title: 'Usari',
            dataIndex: 'pagador',
            width: 30,
            filterSearch: true,
            filters: filtreUsuari,
            onFilter: (value, record) => (typeof value === 'string' ?
                record.pagador.toLowerCase().trim().startsWith(value.toLowerCase().trim()) : false),
        },
        {
            key: 'noms',
            title: 'Noms Infants',
            dataIndex: 'noms',
            width: 30,
            filterSearch: true,
            filters: filtreInfant,
            onFilter: (value, record) => {
                //console.log("value: "+value);
                if (typeof value === 'string' && Array.isArray(record.noms)) {
                    return record.noms.some((nom: string) => {
                        //console.log("nom:" + nom.toLowerCase().trim());
                        //console.log("includes: " +nom.toLowerCase().trim().includes(value.toLowerCase().trim()));
                        return nom.toLowerCase().trim().includes(value.toLowerCase().trim());
                    });
                }
                return false;
            },
            render: (estat, ele) => (
                <>
                    {ele.infants?.map((infant: any, index: number) => (
                        <Popover content={(
                            <div>
                                <p>{infant.comentaris}</p>
                                <p>{infant.observacions}</p>
                            </div>
                        )}
                                 title="Comentaris" trigger="click">
                            <Tag key={index}
                                 color={infant.comentaris !== '' || infant.observacions !== '' ? Colors.colors.color1 : Colors.colors.color5}>
                                {infant.nom}
                            </Tag>
                        </Popover>
                    ))}
                </>
            )
        },
        {
            key: 'dni',
            title: 'DNI',
            dataIndex: 'dni',
            width: 30,
            filterSearch: true,
            filters: filtreDni,
            onFilter: (value, record) => (typeof value === 'string' ? record.dni.startsWith(value) : false),
        },
        {
            key: 'preu',
            title: 'Preu Inscripció',
            dataIndex: 'preu',
            width: 30,
            render: (estat, ele) => (
                <Popover content={(
                    <div>
                        {ele.productes?.map((product: any, index: number) => (
                            <div key={index} style={{marginBottom: '10px'}}>
                                <p><strong>{product.infant}:&nbsp;</strong>{product.descripcio} ({product.preu}&euro;)
                                    - {product.alta}</p>
                            </div>
                        ))}
                    </div>
                )}
                         title="Productes Contractats" trigger="click">
                    <Tag color={"geekblue"}>{ele.preu}&euro;</Tag>
                </Popover>

            )
        },
        {
            key: 'estat',
            title: 'Estat',
            dataIndex: 'estat',
            width: 30,
            filterSearch: true,
            filters: filtreEstat,
            onFilter: (value, record) => {
                if (typeof value === 'number') {
                    return record.estat === value;
                }
                return false;
            },
            render: (estat, ele) => (
                <Popover content={(
                    <div>
                        <p>data d'alta: {ele.alta}</p>
                        <p>imatge: {ele.imatge === 1 ? "Sí" : "No"}</p>
                        <p>recollida: {ele.recollida === 1 ? "Sí" : "No"}</p>
                        <p>notificacions: {ele.notificacions === 1 ? "Sí" : "No"}</p>
                    </div>
                )}
                         title="Informació" trigger="click">
                    <Tag color={ele.estat === 1 ? "blue" : "green"}>{ele.estat === 1 ? "NO VALIDAT" : "VALIDAT"}</Tag>
                </Popover>

            )
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 210,
            render: (estat, ele) => (
                <>
                    {permisosEdicio && (
                        <>
                            {ele.estat === 1 &&
                                <>

                                    <Popover content={
                                        <div>
                                            <p>Amb aquest botó accedeixes a la inscripció com si fosis les families. Si
                                                es finalitza
                                                s'enviarà el correu amb normalitat.</p>
                                        </div>
                                    } title="Editar Inscripció">
                                        <Button title={"Editar Inscripció"} onClick={() => editarInscripcio(ele)}
                                                style={{backgroundColor: Colors.colors.color3}}><BsPencil/></Button>
                                    </Popover>
                                    {" "}
                                    <Popover content={
                                        <div>
                                            <p>Amb aquest botó es marcarà la inscripció com a validada i es generarà un
                                                rebut.</p>
                                        </div>
                                    } title="Validar Inscripció">
                                        <Popconfirm
                                            title="Validar Inscripció"
                                            description="Vols validar i facturar aquesta inscripció?"
                                            onConfirm={() => validar(ele.id)}
                                            icon={<QuestionCircleOutlined style={{color: 'orange'}}/>}
                                        >
                                            <Button title={"Validar"}
                                                    style={{backgroundColor: Colors.colors.color4}}><BsCheck/></Button>
                                        </Popconfirm>
                                    </Popover>
                                    {" "}
                                    <Popover content={
                                        <div>
                                            <p>Amb aquest botó s'enviarà un email a les families informant de que la
                                                insripció
                                                és errònia i es marcará en estat 'ERROR' fins que la modifiquin.</p>
                                        </div>
                                    } title="Informar error a l'inscripció">
                                        <Popconfirm
                                            title="Informar error a l'inscripció"
                                            description="Vols informar a les families de que s'ha de tornar a fer l'inscripció degut a que no está finalitzada correctament?"
                                            onConfirm={() => informarError(ele)}
                                            icon={<QuestionCircleOutlined style={{color: 'orange'}}/>}
                                        >
                                            <Button title={"Informar Inscripció Erronea"}
                                                    style={{backgroundColor: Colors.colors.color5}}><BsBellSlash/></Button>
                                        </Popconfirm>
                                    </Popover>
                                </>
                            }
                            {ele.estat >= 2 &&
                                <>
                                    <Popover content={
                                        <div>
                                            <p>Amb aquest botó pots afegir contactes (autoritzats) a una inscripció ja
                                                validada.</p>
                                        </div>
                                    } title="Afegir autoritzat">
                                        <Button title={"Informar Falta de Documentació"}
                                                onClick={() => afegirAutoritzat({id: 0})}
                                                style={{backgroundColor: Colors.colors.color1}}><BsPersonCheck/></Button>
                                    </Popover>
                                    {" "}
                                    <Popover content={
                                        <div>
                                            <p>Amb aquest botó s'enviarà un email a les families informant de que falta
                                                documentació.</p>
                                        </div>
                                    } title="Informar falta de documentació">
                                        <Popconfirm
                                            title="Informar falta de documentació"
                                            description="Vols informar a les families de la falta de documentació a la inscripció?"
                                            onConfirm={() => faltaDocumentacio(ele)}
                                            icon={<QuestionCircleOutlined style={{color: 'orange'}}/>}
                                        >
                                            <Button title={"Informar Falta de Documentació"}
                                                    style={{backgroundColor: Colors.colors.color3}}><BiErrorCircle/></Button>
                                        </Popconfirm>
                                    </Popover>
                                    {" "}
                                    <Popover content={
                                        <div>
                                            <p>Amb aquest botó pots afegir infants a una inscripció ja validada.</p>
                                        </div>
                                    } title="Afegir Infant">
                                        <Button title={"Afegir Infant"} onClick={() => afegirInfant(ele)}
                                                style={{backgroundColor: Colors.colors.color4}}><BsPerson/></Button>
                                    </Popover>
                                    {" "}
                                    <Popover content={
                                        <div>
                                            <p>Amb aquest botó pots afegir una nova inscripció (per a un nou infant o
                                                per
                                                el mateix infant però en un altre casal) a una inscrició ja
                                                validada.</p>
                                        </div>
                                    } title="Nova inscripció">
                                        <Button title={"Nova inscripció"} onClick={() => afegirInscripcio(ele)}
                                                style={{backgroundColor: Colors.colors.color5}}><BsPersonAdd/></Button>
                                    </Popover>
                                </>
                            }
                            {" "}
                            <Popover content={
                                <div>
                                    <p>Amb aquest botó pases la inscripció a 'PENDENT'.</p>
                                </div>
                            } title="Eliminar Inscripció">
                                <Popconfirm
                                    title="Eliminant"
                                    description="Vols eliminar aquesta inscripció? El seu estat pasarà a estar en PENDENT."
                                    onConfirm={() => deleteElement(ele)}
                                    icon={<QuestionCircleOutlined style={{color: 'red'}}/>}
                                >
                                    <Button title={"Eliminar"}
                                            style={{backgroundColor: Colors.colors.color6}}><BiTrash/></Button>
                                </Popconfirm>
                            </Popover>
                        </>
                    )}
                </>
            ),
        }
    ];

    const tableProps: TableProps<any> = {
        loading
    };

    async function handleDownload(id: string) {
        setLoading(true);
        //const documentUrl = await GetComandesGeneradesIdPdf(page, id);
        const documentUrl = ""; //TODO: delete

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `facturaRemesa${id}.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setLoading(true);
    };

    const {RangePicker} = DatePicker;

    function changeActivitat(id_activitat: string) {
        setIdActivitat(id_activitat);
        checkDades(id_activitat);
    }

    const colorsArray = [Colors.colors.color1, Colors.colors.color2, Colors.colors.color4, Colors.colors.color5, Colors.colors.color6];

    async function togleNouElementDocument(ele: any, b: boolean) {
        const dds3 = await GetInscripcionsIdAlumneIdDocuments(ele.id + "", ele.id_alumne_casal + "", page);
        setDocs(dds3.fileList);
        setShowDocuEle(ele);
        setShowDocu(true);
    }

    function editarContacte(ele: any) {
        setSelectedContacte(ele);
        console.log(JSON.stringify(ele));
        if (ele.pagador === 1) {
            setContacteModal(true);
        } else {
            setContactesModal(true);
        }
    }

    async function showDocuments(ele: any, b: boolean) {
        const dds3 = await GetInscripcionsIdAlumneIdDocuments(ele.id + "", ele.id_alumne_casal + "", page);
        setDocs(dds3.fileList);
        setShowDocuEle(ele);
        setDocumentacioModal(true);
    }

    const expandedRowRender = (record: any) => {
        const columns: TableColumnsType<any> = [
            {
                key: 'key',
                title: 'ID',
                dataIndex: 'key',
                width: 30
            },
            {
                key: 'nom Infant',
                title: 'Nom',
                dataIndex: 'nom',
                width: 30,
                render: (infant, ele) => (
                    <Popover content={(
                        <div>
                            <p>{ele.comentaris}</p>
                            <p>{ele.observacions}</p>
                        </div>
                    )}
                             title="Comentaris" trigger="click">
                        <Tag key={ele.key} color={Colors.colors.color5}>
                            {ele.nom}&nbsp;{(ele.comentaris !== '' || ele.observacions !== '') && <BiMessage/>}
                        </Tag>
                    </Popover>
                )
            },
            {
                key: 'casal',
                title: 'Casal - Campus',
                dataIndex: 'casal',
                width: 100,
                render: (estat, ele) => (
                    <>
                        <p><strong>Casal: </strong>{ele.casal}</p>
                        <p><strong>Campus: </strong>{ele.campus}</p>
                    </>
                )
            },
            {
                key: 'setmanes',
                title: 'Setmanes',
                dataIndex: 'setmanes',
                width: 30,
                render: (estat, ele) => (
                    <>
                        {ele.configuracions?.length > 0 ? ele.configuracions.map((elemento: any, index: number) => (
                            <div key={index}>
                                {elemento.setmanesNumeros.map((setmana: any, idx: number) => (
                                    <Tag color={colorsArray[index % colorsArray.length]} key={idx}>
                                        {setmana} - {elemento.nom_torn}
                                    </Tag>
                                ))}
                                {elemento.diesNumeros.map((setmana: any, idx: number) => (
                                    <Tag color={colorsArray[index % colorsArray.length]} key={idx}>
                                        {setmana} - {elemento.nom_torn}
                                    </Tag>
                                ))}
                            </div>
                        )) : <Tag color={"red"}>CAP SETMANA!!</Tag>}
                    </>
                )
            },
            {
                key: 'estat',
                title: 'Estat',
                dataIndex: 'estat',
                width: 30,
                render: (estat, ele) => (
                    <Tag color={ele.estat === 1 ? "blue" : "green"}>{ele.estat === 1 ? "NO VALIDAT" : "VALIDAT"}</Tag>
                )
            },
            {
                key: 'alergensNoms',
                title: 'Al·lergens',
                dataIndex: 'alergensNoms',
                width: 30
            },
            {
                key: 'accions', title: 'Accions', dataIndex: 'accions', width: 240,
                render: (estat, ele) => (
                    <>
                        {permisosEdicio && (
                            <>
                                <Popover content={
                                    <div>
                                        <p>Amb aquest botó es pot modificar la inscripció de l'infant (casal, campus,
                                            setmanes, etc.).</p>
                                    </div>
                                } title="Modificar Inscripció">
                                    <Button title={"Calendari"} style={{backgroundColor: Colors.colors.color6}}
                                            onClick={() => togleNouElement(ele, true)}><BiCalendar/></Button>
                                </Popover>
                                {" "}
                                <Popover content={
                                    <div>
                                        <p>Amb aquest botó es pot modificar o penjar la documentació de la inscripció de
                                            l'infant.</p>
                                    </div>
                                } title="Pujar Documents">
                                    <Button title={"Pujar Documents"} style={{backgroundColor: Colors.colors.color5}}
                                            onClick={() => togleNouElementDocument(ele, true)}><BiDetail/></Button>
                                </Popover>
                                {" "}
                                <Popover content={
                                    <div>
                                        <p>Amb aquest botó es poden veure i descarregar els documents de l'infant.</p>
                                    </div>
                                } title="Mostrar Documents">
                                    <Button title={"Mostrar Documents"} style={{backgroundColor: Colors.colors.color4}}
                                            onClick={() => showDocuments(ele, true)}><BiCard/></Button>
                                </Popover>
                                {" "}
                                <Popover content={
                                    <div>
                                        <p>Amb aquest botó marca com a `Validat` l'infant. Es una manera de marcar que
                                            s'ha revisat tota la documentació.</p>
                                    </div>
                                } title="Validar Infant">
                                    <Button title={"Validar"} style={{backgroundColor: Colors.colors.color3}}
                                            onClick={() => validarAlumne(ele)}><BiCheck/></Button>
                                </Popover>
                                {" "}

                                <Popover content={
                                    <div>
                                        <p>Amb aquest treus de la inscripció a l'infant.</p>
                                    </div>
                                } title="Eliminar Infant">
                                    <Popconfirm
                                        title="Eliminant"
                                        description="Vols eliminar definitivament aquest infant de l'inscripció? La resta de la inscripció continuarà igual."
                                        onConfirm={() => deleteElementAlu(ele)}
                                        icon={<QuestionCircleOutlined style={{color: 'red'}}/>}
                                    >
                                        <Button title={"Eliminar"}
                                                style={{backgroundColor: Colors.colors.color1}}><BiTrash/></Button>
                                    </Popconfirm>
                                </Popover>
                            </>
                        )}
                    </>
                )
            }
        ];

        const filteredInfants = record.infants?.filter((infant: {
            id_inscripcio: any;
        }) => infant.id_inscripcio === record.id);


        const columns2: TableColumnsType<any> = [
            {
                key: 'id',
                title: 'ID',
                dataIndex: 'id',
                width: 30
            },
            {
                key: 'nomComplet',
                title: 'Nom Contacte',
                dataIndex: 'nomComplet',
                width: 30,
                render: (infant, ele) => (
                    <Popover content={(
                        <div>
                            <p>{ele.comentaris}</p>
                            <p>{ele.observacions}</p>
                        </div>
                    )}
                             title="Comentaris" trigger="click">
                        <Tag key={ele.key} color={Colors.colors.color5}>
                            {ele.nomComplet}&nbsp;{(ele.comentaris !== '' || ele.observacions !== '') && <BiMessage/>}
                        </Tag>
                    </Popover>
                )
            },
            {
                key: 'email',
                title: 'Email',
                dataIndex: 'email',
                width: 30
            },
            {
                key: 'dni',
                title: 'DNI',
                dataIndex: 'dni',
                width: 30
            },
            {
                key: 'iba1',
                title: 'IBAN/Efectiu',
                dataIndex: 'iba1',
                width: 30,
                render: (estat, ele) => (
                    <>
                        {ele.pagador === 0 && <Tag color={Colors.colors.color5}>{"AUTORITZAT"}</Tag>}
                        {ele.pagador === 1 &&
                            <Tag color={Colors.colors.color3}>{ele.metalic ? <BsCash/> : ele.iba1}</Tag>}
                    </>
                ),
            },
            {
                key: 'rebuts',
                title: 'Rebuts',
                dataIndex: 'rebuts',
                width: 30,
                render: (estat, ele) => (
                    <>
                        {ele.pagador === 0 && <Tag color={Colors.colors.color4}>{ele.parentesc}</Tag>}
                        {ele.pagador === 1 && ele.rebutspendent > 0 &&
                            <Tag color={"orange"} onClick={() => tickets(ele)}>{ele.rebutspendent}&nbsp;
                                <BsTicket/></Tag>}
                        {ele.pagador === 1 && ele.rebutspagat > 0 &&
                            <Tag color={Colors.colors.color3} onClick={() => tickets(ele)}>{ele.rebutspagat}&nbsp;
                                <BsTicket/></Tag>}
                        {ele.pagador === 1 && ele.rebutsretornat > 0 &&
                            <Tag color={"red"} onClick={() => tickets(ele)}>{ele.rebutsretornat}&nbsp;<BsTicket/></Tag>}
                    </>
                ),
            },
            {
                key: 'telefons',
                title: 'Telèfons',
                dataIndex: 'telefons',
                width: 30,
                render: (estat, ele) => (
                    <>
                        <Tag color={Colors.colors.color1}>{ele.telefon !== "0" ? ele.telefon : ""}</Tag>
                        <Tag color={Colors.colors.color3}>{ele.telefon2 !== "0" ? ele.telefon2 : ""}</Tag>
                        <Tag color={Colors.colors.color4}>{ele.telefon3 !== "0" ? ele.telefon3 : ""}</Tag>
                    </>
                ),
            },
            {
                key: 'accions', title: 'Accions', dataIndex: 'accions', width: 170,
                render: (estat, ele) => (
                    <>
                        {permisosEdicio && (
                            <>
                                <Popover content={
                                    <div>
                                        <p>Amb aquest botó es pot modificar la informació del contacte.</p>
                                    </div>
                                } title="Editar Contacte">
                                    <Button title={"Editar Contacte"} onClick={() => editarContacte(ele)}
                                            style={{backgroundColor: Colors.colors.color6}}><BsPencil/></Button>
                                </Popover>
                                {" "}
                                <Popover content={
                                    <div>
                                        <p>Amb aquest botó es es poden veure els rebuts del contacte d'aquesta
                                            activitat.</p>
                                    </div>
                                } title="Veure Rebuts">
                                    <Button title={"Veure Rebuts"} onClick={() => tickets(ele)}
                                            style={{backgroundColor: Colors.colors.color5}}><BsTicket/></Button>
                                </Popover>
                                {" "}

                                <Popover content={
                                    <div>
                                        <p>Amb aquest botó tornes a generar el rebut d'aquesta inscrició. Es en casos en
                                            que els productes son correctes però no s'ha generat rebut. Revisa els
                                            productes fent 'click' al preu..</p>
                                    </div>
                                } title="Tornar a generar Rebut">
                                    <Popconfirm
                                        title="Tornar a generar Rebut"
                                        description="Vols tornar a generar el rebut per aquesta inscripció? Revisa primer el preu i els productes! També revisa que no tingui asignat un alre pagador el rebut filtrant per nom de pagador a la pestanya de rebuts."
                                        onConfirm={() => validar(ele.id_inscripcio)}
                                        icon={<QuestionCircleOutlined style={{color: 'orange'}}/>}
                                    >
                                        <Button title={"Tornar a generar Rebut"}
                                                style={{backgroundColor: Colors.colors.color4}}><BsTicketPerforatedFill/></Button>
                                    </Popconfirm>
                                </Popover>
                            </>
                        )}
                    </>
                )
            }
        ];

        const filteredContactes = record.contactes?.filter((contacte: {
            id_inscripcio: any;
        }) => contacte.id_inscripcio === record.id);

        //return <Table columns={columns} dataSource={filteredContactes} pagination={false}/>;

        return <Card>
            <h5 style={{color: Colors.colors.color2}}>INFANTS</h5>
            <Table columns={columns} dataSource={filteredInfants} pagination={false}/>
            <hr/>
            <h5 style={{color: Colors.colors.color4}}>CONTACTES</h5>
            <Table columns={columns2} dataSource={filteredContactes} pagination={false}/>
        </Card>;
    };


    function handleCloseModalDocu() {
        setShowDocu(false);
    }

    const setmanes = [
        {value: "0", label: "TOTES"},
        {value: "1", label: "Setmana-1"},
        {value: "2", label: "Setmana-2"},
        {value: "3", label: "Setmana-3"},
        {value: "4", label: "Setmana-4"},
        {value: "5", label: "Setmana-5"},
        {value: "6", label: "Setmana-6"},
    ];

    function changeCasal(element: any) {
        const selectedCasal = filtreCasal.find((casal: any) => casal.value === element);

        setFiltreCampus(selectedCasal.campus);
        setFiltreOpcio(selectedCasal.opcions);
        const newFiltres = {...filtres, idCampus: 0, idOpcio: 0}
        setFiltres(newFiltres);
    }


    function clear() {
        setFiltreCampus([]);
        setFiltreCasal([]);
        setFiltreOpcio([]);
    }

    const content = (
        <div>
            <p>1) Aplica els <b>filtres</b> genèrics <Button title={"Mostrar Filtres"}
                                                             style={{backgroundColor: Colors.colors.color5}}><BiFilter/></Button> o
                específics des de la taula.</p>
            <p>2) <b>Marca els rebuts</b> que vols facturar.</p>
            <p><p style={{color: "red"}}><b>IMPORTANT!</b></p> Has de marcar <b>página per página</b> tots els rebuts.
            </p>
            <p>3) <b>Prem el botó</b> <Button title={"Generar Remesa"}
                                              style={{backgroundColor: Colors.colors.color5}}>GENERAR REMESA&nbsp;
                <BiEuro/></Button></p>
            <p>4) Automàticament es redirigeix a la pantalla de <b>Remeses</b> on es pot descarregar la remesa.</p>
        </div>
    );

    if (isLoggedIn) {
        return (
            <div>
                <Toaster/>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades(idActivitat)}><BiRefresh/></Button>
                            <Button title={"Mostrar filtres"} style={{backgroundColor: Colors.colors.color5}}
                                    disabled={!showFiltersButton}
                                    onClick={() =>
                                        setShowFilters(!showFilters)}><BiFilter/></Button>
                            {descarregar &&
                                <Button title={"Descarregar llistats"} style={{backgroundColor: Colors.colors.color6}}
                                        onClick={() => setDescarregarModal(true)}><BiDownload/></Button>}
                        </div>
                        {showFilters && (
                            <>
                                <br/>
                                <br/>
                                <br/>
                                <Form form={form} initialValues={filtres} onFinish={handleSubmit}>
                                    <Form.Item style={{marginBottom: 0}}>
                                        <Form.Item
                                            name="activitat"
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}
                                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}
                                        >
                                            <Select showSearch
                                                    disabled={activitats.length === 0}
                                                    placeholder="Selecciona Activitat"
                                                    optionFilterProp="children"
                                                    onChange={changeActivitat}
                                                    options={activitats}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            name="idCasal"
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}
                                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}
                                        >
                                            <Select showSearch
                                                    disabled={filtreCasal.length < 0}
                                                    placeholder="Selecciona Casal"
                                                    optionFilterProp="children"
                                                    onChange={changeCasal}
                                                    options={filtreCasal}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            name="idCampus"
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}
                                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}
                                        >
                                            <Select showSearch
                                                    disabled={filtreCampus.length < 0}
                                                    placeholder="Selecciona Campus"
                                                    optionFilterProp="children"
                                                    options={filtreCampus}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            name="idOpcio"
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}
                                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}
                                        >
                                            <Select showSearch
                                                    disabled={filtreOpcio.length < 0}
                                                    placeholder="Selecciona Opció"
                                                    optionFilterProp="children"
                                                    options={filtreOpcio}
                                            />
                                        </Form.Item>
                                        <br/>
                                        <br/>
                                        <Form.Item
                                            name="setmana"
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}
                                        >
                                            <Select showSearch
                                                    disabled={filtreCasal.length < 0}
                                                    placeholder="Selecciona Setmana"
                                                    optionFilterProp="children"
                                                    options={setmanes}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}>
                                            <Button title={"Aceptar"} htmlType={"submit"}
                                                    style={{backgroundColor: Colors.colors.color6}}><BiSearch/></Button>
                                            {" "}
                                            <Button title={"Borrar filtres"} onClick={clear}
                                                    style={{backgroundColor: Colors.colors.color1}}><BiTrash/></Button>
                                        </Form.Item>
                                        <Form.Item
                                            style={{
                                                display: 'inline-block',
                                                width: 'calc(22% - 8px)',
                                                margin: '0 8px'
                                            }}>
                                        </Form.Item>
                                    </Form.Item>
                                </Form>
                                <br/>
                            </>
                        )}
                        <h4 className={"titol"}>{titol}</h4>
                        {visible && (
                            <>
                                <Alert type={"info"}
                                       message={"Pots veure els comentaris fent `click` al nom de l'infant. El infants amb comentaris estan de color més fosc!"}/>
                                <Alert type={"warning"}
                                       message={"Pots veure els productes contractats fent `click` al preu de la inscripció."}/>
                                <Table
                                    {...tableProps}
                                    columns={columns}
                                    expandable={{expandedRowRender}}
                                    dataSource={coleccio}
                                />
                            </>
                        )}
                    </Card>
                    <br/>
                    <Historials pantalla={"PLANTILLA"} pagina={page}/>
                    {nouElement && (
                        <InscripcioModal element={elementSelected} onClose={handleCloseModal} visible={nouElement}
                                         page={page} edit={true}/>
                    )}
                    {showDocu && (
                        <InscripcioModalDocumentacio idInsc={showDocuEle.id_inscripcio} element={showDocuEle}
                                                     visible={showDocu} page={page} onClose={handleCloseModalDocu}
                                                     documents={docs}/>
                    )}
                    {descarregarModal && (
                        <InscripcionsDescarregar llistes={llistats} element={{id: idActivitat}}
                                                 escolesList={filtreCasal}
                                                 onClose={() => setDescarregarModal(false)} visible={descarregar}
                                                 extresList={filtreExtres}
                        />
                    )}
                    {infantModal && (
                        <InfantModal element={infantSelected} visible={infantModal} page={page}
                                     onClose={handleCloseModal}/>
                    )}
                    {inscripcioInfantModal && (
                        <InscripcioModal element={elementSelected} onClose={handleCloseModalContacte}
                                         visible={inscripcioInfantModal} page={page} edit={false}/>
                    )}
                    {contacteModal && (
                        <PagadorModal element={selectedContacte} onClose={handleCloseModalContacte}
                                      visible={contacteModal}/>
                    )}
                    {documentacioModal && (
                        <DocumentacioModal element={showDocuEle} visible={documentacioModal} page={page}
                                           onClose={handleCloseModal} documents={docs}
                                           idInsc={showDocuEle.id_inscripcio}/>
                    )}
                    {contactesModal && (
                        <AutoritzatModal onClose={handleCloseModalContacte} element={selectedContacte}
                                         visible={contactesModal} idInsc={selectedContacte.id + ""}/>
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default InscripcionsE;
